// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"oFZrB","isSelected":"bUKjR"};